import { jsx as _jsx } from "react/jsx-runtime";
import { useRecoilCallback, useRecoilValue } from 'recoil';
import { removeToastSelector, temporalToastSelector } from '@/state/config';
import { Toast } from './Toast';
const SHOW_DURATION_MS = 3500;
export const ToastsWrapper = () => {
    const toasts = useRecoilValue(temporalToastSelector);
    const removeToast = useRecoilCallback(({ snapshot, set }) => (id) => {
        const loadable = snapshot.getLoadable(removeToastSelector(id));
        if (loadable.state === 'hasValue') {
            set(removeToastSelector(id), loadable.contents);
        }
    });
    return (_jsx("div", { className: "-y-2 absolute bottom-[calc(100%+40px)] left-0 right-0 mx-auto flex w-full flex-col items-center gap-2 px-3", children: toasts.map((toast, index) => (_jsx(Toast, { toast: toast, onRemove: removeToast, timeToRemove: SHOW_DURATION_MS + index * 1000 }, toast.id))) }));
};
